import {
  WSAvatar,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { IconInstitution } from "../../../../shared/components/IconInstitution";
import { selectorCountryName } from "../../../../shared/selectors/selectorCountryName";
import { getCountyFlagLink } from "../../../../shared/utils/countries";
import { selectorExternalBankAccountCountry } from "@selectors/selectorExternalBankAccountCountry";
import { selectorExternalBankAccountInstitution } from "@selectors/selectorExternalBankAccountInstitution";
import { selectorExternalBankAccountName } from "@selectors/selectorExternalBankAccountName";

type Props = { externalBankAccount: ExternalBankAccount } & WSElementProps;

export const BankAccount: React.FC<Props> = ({
  externalBankAccount,
  ...elementProps
}) => {
  const country = selectorExternalBankAccountCountry(externalBankAccount);
  const isInternational = !!country && country !== "US";
  const title = isInternational
    ? `${selectorCountryName(country)} (${externalBankAccount.currency})`
    : selectorExternalBankAccountInstitution(externalBankAccount);
  const description = selectorExternalBankAccountName(externalBankAccount);

  return (
    <WSFlexBox wrap="nowrap" alignItems="center" {...elementProps}>
      {isInternational ? (
        <WSAvatar.Image
          image={getCountyFlagLink(country.toLowerCase())}
          colorBackground="gray50"
          mr="M"
        />
      ) : (
        <IconInstitution mr="M" />
      )}
      <WSScreen.Mobile>
        <WSElement>
          {title && (
            <WSText weight="medium" mr="M">
              {title}
            </WSText>
          )}
          <WSText.ParagraphSm color="gray500">{description}</WSText.ParagraphSm>
        </WSElement>
      </WSScreen.Mobile>
      <WSScreen.TabletAndDesktop>
        {title && (
          <WSText weight="medium" mr="M">
            {title}
          </WSText>
        )}
        <WSText color="gray500">{description}</WSText>
      </WSScreen.TabletAndDesktop>
    </WSFlexBox>
  );
};
